import cls from "classnames";
import lodash from "lodash";
import PropTypes from "prop-types";
import React from "react";
import { RicosContext } from "./../../../ricos-context/index.js";
import { LoaderIcon } from "../../assets/icons/loader-icon.js";
import { RCEHelpersPropTypes, withRCEHelpers } from "../rce-helpers-context/index.js";
import styles from "./text-field-scss.js";
class TextFieldComponent extends React.PureComponent {
  constructor() {
    super(...arguments);
    this.$el = React.createRef();
    this.state = {
      placeholder: this.props.placeholder,
      rows: 1,
      syncing: false,
      isFocused: false
    };
    this.handleWindowResizeEvent = () => setTimeout(() => this.resize());
    this.handleFocus = (e) => {
      e.stopPropagation();
      setTimeout(() => this.resize());
      this.hidePlaceholder();
      this.props.rce.setInPluginEditingMode(true);
      this.setState({ isFocused: true });
    };
    this.handleBlur = () => {
      setTimeout(() => this.resize());
      this.showPlaceholder();
      this.props.rce.setInPluginEditingMode(false);
      this.setState({ isFocused: false });
    };
    this.handleChange = (event) => {
      this.props.onChange(event.target.value);
      this.resize();
    };
  }
  componentDidMount() {
    const { rce } = this.props;
    const isEditMode = !rce.isViewMode;
    if (isEditMode) {
      this.resize();
    }
    this.handleAutoFocus();
    window?.addEventListener("resize", this.handleWindowResizeEvent);
  }
  componentDidUpdate(props) {
    if (this.props.rce.isViewMode === props.rce.isViewMode) {
      return;
    }
    this.handleAutoFocus();
  }
  handleAutoFocus() {
    const { rce, autofocus } = this.props;
    const isEditMode = !rce.isViewMode;
    if (autofocus && isEditMode && rce.isOnlySelected) {
      this.$el.current?.focus();
    }
  }
  componentWillUnmount() {
    window?.removeEventListener("resize", this.handleWindowResizeEvent);
  }
  hidePlaceholder() {
    this.setState({ placeholder: "" });
  }
  showPlaceholder() {
    this.setState({ placeholder: this.props.placeholder });
  }
  handleKeyDown(event) {
    if (event.key === "Enter") {
      event.preventDefault();
    }
  }
  resize() {
    const { jsdomMode } = this.context;
    if (!this.$el.current || jsdomMode) {
      return;
    }
    const computedStyles = getComputedStyle(this.$el.current);
    const lineHeight = parseInt(computedStyles.lineHeight);
    const paddingTop = parseInt(computedStyles.paddingTop);
    const paddingBottom = parseInt(computedStyles.paddingBottom);
    this.$el.current.rows = 1;
    const { scrollHeight } = this.$el.current;
    this.$el.current.rows = this.state.rows;
    const contentHeight = scrollHeight - (paddingTop + paddingBottom);
    const rows = Math.ceil(lodash.clamp(contentHeight / lineHeight, 1, Infinity));
    this.setState({ rows });
  }
  render() {
    const {
      dataHook,
      textAutoResize,
      className,
      rce,
      endAdornment,
      style,
      children,
      startAdornment,
      maxLength,
      disabled,
      value
    } = this.props;
    const { placeholder, rows, syncing, isFocused } = this.state;
    if (rce.isViewMode || rce.isPreview) {
      return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
        "p",
        {
          style,
          className: cls(
            styles.text,
            className,
            textAutoResize && {
              [styles.small]: value.length > 120,
              [styles.medium]: value.length <= 120,
              [styles.large]: value.length <= 80
            },
            {
              [styles.webview]: rce.isWebView
            }
          )
        },
        startAdornment,
        children,
        /* @__PURE__ */ React.createElement("span", { className: styles.value, "data-hook": dataHook }, this.props.value || this.props.placeholder)
      ));
    }
    return /* @__PURE__ */ React.createElement("div", { className: styles.root }, startAdornment, /* @__PURE__ */ React.createElement(
      "textarea",
      {
        "data-hook": dataHook,
        disabled,
        maxLength,
        style,
        ref: this.$el,
        onChange: this.handleChange,
        onFocus: this.handleFocus,
        onBlur: this.handleBlur,
        placeholder,
        value,
        rows,
        onKeyDown: this.handleKeyDown,
        className: cls(
          styles.input,
          className,
          textAutoResize && {
            [styles.small]: value.length > 120,
            [styles.medium]: value.length <= 120,
            [styles.large]: value.length <= 80
          }
        ),
        onClick: void 0
      }
    ), /* @__PURE__ */ React.createElement(
      "span",
      {
        className: cls(styles.endAdornment, {
          [styles.shown]: syncing || isFocused
        })
      },
      syncing ? /* @__PURE__ */ React.createElement(LoaderIcon, { className: styles.spinner }) : endAdornment
    ));
  }
}
TextFieldComponent.contextType = RicosContext;
const TextField = withRCEHelpers(TextFieldComponent);
TextFieldComponent.defaultProps = {
  maxLength: 500,
  disabled: false
};
TextFieldComponent.propTypes = {
  dataHook: PropTypes.string,
  autofocus: PropTypes.bool,
  maxLength: PropTypes.number,
  value: PropTypes.string,
  disabled: PropTypes.string,
  className: PropTypes.string,
  onChange: PropTypes.func,
  placeholder: PropTypes.string.isRequired,
  textAutoResize: PropTypes.bool,
  startAdornment: PropTypes.node,
  endAdornment: PropTypes.node,
  ...RCEHelpersPropTypes
};
export {
  TextField
};
//# sourceMappingURL=text-field.js.map
